import { UmbracoBlock } from '@web/services/umbraco/types/basic/Block';
import { Guid } from '@web/services/umbraco/types/basic/Guid';

let index = 0;

export function getBlockFixture<
	Name extends string,
	Props extends Record<string, unknown> = {},
	Settings extends Record<string, unknown> = {}
>(
	name: Name,
	props: Props,
	settings: Settings = {} as Settings,
	key?: string | Guid,
): UmbracoBlock<Name, Props, Settings> {
	const fixtureKey = (key || `${name}-${index}`) as unknown as Guid;

	const block: UmbracoBlock<Name, Props, Settings> = {
		__typename: 'CustomBlockListItem',
		contentAlias: name,
		key: fixtureKey,
		contentProperties: props,
		settingsProperties: settings,
	};

	index += 1;

	return block;
}
